import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { NavigationService } from "src/app/providers/navigation.service";
import { TargetsListComponent } from "../targets-list/targets-list.component";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";

@Component({
  selector: "sm-create-promotion-campaign",
  templateUrl: "./create-promotion-campaign.component.html",
  styleUrls: ["./create-promotion-campaign.component.scss"],
})
export class CreatePromotionCampaignComponent implements OnInit, OnDestroy {
  isEntityIndividual: any = sessionStorage.getItem("isEntityIndividual");
  promotionChecks = {
    whatsapp: false,
    email: false,
    sms: false,
  };
  promotionData: any = {
    target_type: "1",
    campaign_progress: 0,
    all_customers: 1,
    targetArr: [],
    promotion_type: 0,
  };
  loader: boolean = false;
  assetList: any = [];
  apisub: Subscription;
  selectedValue: any = "1";
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private dialog: MatDialog,
    private navservice: NavigationService,
    private apiservice: ApiService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private ls: LoaderServiceService,
    private activemodal: MatDialogRef<CreatePromotionCampaignComponent>
  ) {
    this.navservice.hideSidebarAndNav = false;

    this.apisub = this.apiservice.apiResult.subscribe((res) => {
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        setTimeout(() => {
          this.assetList = [];
          console.log(res.result);
          this.assetList.push({
            assetName: this.fileName,
            url: res.result?.url,
            thumbnail: res.result?.thumbnail,
          });
          this.promotionData.media_url = res.result?.url;
          this.promotionData.media_thumb_url = res.result?.thumbnail;
          // this.serviceListData.thumbUrl = res.result?.thumbnail;
          this.loader = false;
        }, 3000);
      }
      if (
        res.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_WHATSAPP_CAMPAIGN
      ) {
        if (res.result) {
          this.activemodal.close({ msg: "success" });
          //   if(res.result.errorcode == 0){

          //   }else{
          //   this.ls.showLoader = false
          //   const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          //     width: '400px',
          //   data : {
          //     title : 'Alert',
          //     message : res.result.msg,
          //     okbtn : 'Ok',
          //     cancelbtn : 'Cancel',
          //     type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
          //   },
          //   disableClose : true
          // });
          //   }
        }
      }
    });
  }
  entityHash: any;
  ngOnInit(): void {
    this.entityHash = this.parentdata.entityHash;
    this.initializePromotionChecks();
  }
  openallcustomer() {
    this.dialog.open(TargetsListComponent, {
      width: "70vw",
    });
  }
  removeAsset() {
    this.promotionData.media_url = "";
    this.promotionData.media_thumb_url = "";
    this.assetList = [];
  }

  fileName: any;
  onUploadImage(event: any) {
    this.loader = true;
    console.log(event.target.files);
    if (event.target.value === "") {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;
    let sizeinKb = +event.target.files[0].size / 1000;
    if (sizeinKb > 5120) {
      this._snackBar.open("Image size should not exceed more then 5 mb", "Ok", {
        duration: 3000,
      });
      return;
    }
    let formData: FormData = new FormData();
    formData.append("recfile", event.target.files[0]);
    this.apiservice.uploadAssets(formData, 1);
  }

  changeChip(value: any) {
    this.selectedValue = value;
    if (this.selectedValue == "1") {
      this.promotionData.targetArr = [];

      this.promotionData.target_type = "1";
      this.promotionData.all_customers = 1;
    } else if (this.selectedValue == "2") {
      this.promotionData.targetArr = [];
      this.promotionData.target_type = "2";
      this.promotionData.all_customers = 1;
    } else if (this.selectedValue == "3") {
      this.promotionData.target_type = "1";
      this.promotionData.all_customers = 0;
      // this.promotionData.targetArr = [];
      this.ls.showLoader = true;
      let dref = this.dialog.open(TargetsListComponent, {
        width: "70vw",
        data: {
          type: "customer",
          prefilled:
            this.promotionData.targetArr.length > 0
              ? this.promotionData.targetArr
              : [],
        },
      });
      dref.afterClosed().subscribe((data) => {
        if (data) {
          console.log(data);

          this.promotionData.targetArr = data;
        }
      });
    } else if (this.selectedValue == "4") {
      this.promotionData.target_type = "2";
      this.promotionData.all_customers = 0;
      // this.promotionData.targetArr = [];
      this.ls.showLoader = true;
      let dref = this.dialog.open(TargetsListComponent, {
        width: "800px",
        data: {
          type: "member",
          prefilled:
            this.promotionData.targetArr.length > 0
              ? this.promotionData.targetArr
              : [],
        },
      });
      dref.afterClosed().subscribe((data) => {
        console.log(data);
        this.promotionData.targetArr = data;
      });
    }
    // all membership
    else if (this.selectedValue == "5") {
      this.promotionData.targetArr = [];
      this.promotionData.target_type = "3";
      this.promotionData.all_customers = 1;
    }
    // selected membership requests
    else if (this.selectedValue == "6") {
      this.promotionData.target_type = "3";
      this.promotionData.all_customers = 0;
      // this.promotionData.targetArr = [];
      this.ls.showLoader = true;
      let dref = this.dialog.open(TargetsListComponent, {
        width: "800px",
        data: {
          type: "query",
          prefilled:
            this.promotionData.targetArr.length > 0
              ? this.promotionData.targetArr
              : [],
        },
      });
      dref.afterClosed().subscribe((data) => {
        console.log(data);
        this.promotionData.targetArr = data;
      });
    }
    // all service queries
    else if (this.selectedValue == "7") {
      this.promotionData.targetArr = [];
      this.promotionData.target_type = "4";
      this.promotionData.all_customers = 1;
    }
    // selected service queries
    else if (this.selectedValue == "8") {
      this.promotionData.target_type = "4";
      this.promotionData.all_customers = 0;
      // this.promotionData.targetArr = [];
      this.ls.showLoader = true;
      let dref = this.dialog.open(TargetsListComponent, {
        width: "800px",
        data: {
          type: "service querie",
          prefilled:
            this.promotionData.targetArr.length > 0
              ? this.promotionData.targetArr
              : [],
        },
      });
      dref.afterClosed().subscribe((data) => {
        console.log(data);
        this.promotionData.targetArr = data;
      });
    }
  }

  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;
  }

  confirm() {
    if (
      this.promotionData.all_customers == 0 &&
      this.promotionData.targetArr.length == 0
    ) {
    } else {
      let data = {
        entity_hash: this.entityHash,
        entity_name: localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_NAME),
        entity_address: localStorage.getItem(
          SM_CONSTANTS.CURRENT_ENTITY_ADDRESS
        ),
        title: this.promotionData.title,
        body: this.promotionData.body,
        external_link: this.promotionData.external_link,
        campaign_cost: 0,
        media_url: this.promotionData.media_url,
        media_thumb_url: this.promotionData.media_thumb_url,
        campaign_start_date: this.formatDate1(
          this.promotionData.campaign_start_date
        ),
        campaign_end_date: this.formatDate1(
          this.promotionData.campaign_end_date
        ),
        campaign_progress: 0,
        target_type: this.promotionData.target_type,
        targetArr: this.promotionData.targetArr,
        all_customers: this.promotionData.all_customers,
        promotion_type: this.promotionData.promotion_type,
      };

      Object.keys(data).forEach((key) => {
        if ((data as any)[key] === null || (data as any)[key] === undefined) {
          delete (data as any)[key];
        }
      });

      console.log(data);

      this.ls.showLoader = true;
      this.apiservice.addEditEntityExternalCampaign(data);
    }
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }

  initializePromotionChecks() {
    const type = this.promotionData.promotion_type;

    this.promotionChecks.whatsapp = (type & 1) !== 0;
    this.promotionChecks.email = (type & 2) !== 0;
    this.promotionChecks.sms = (type & 4) !== 0;
  }

  updatePromotionType() {
    let value = 0;
    if (this.promotionChecks.whatsapp) value += 1;
    if (this.promotionChecks.email) value += 2;
    if (this.promotionChecks.sms) value += 4;

    this.promotionData.promotion_type = value;
  }
}
